import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import './style/global.less';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import rootReducer from './store';
import PageLayout from './layout';
import { GlobalContext } from './context';
import Login from './pages/login2';
import checkLogin from './utils/checkLogin';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import api from '@/api';
// import './mock';

const store = createStore(rootReducer);
function Index() {
  const [lang, setLang] = useStorage('arco-lang', 'zh-CN');
  const [theme, setTheme] = useStorage('arco-theme', 'light');
  const [_, setUserStatus] = useStorage('userStatus');
  const indPage = [
  // '/',
  '/login', '/index'];
  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      case 'en-US':
        return enUS;
      default:
        return zhCN;
    }
  }
  function fetchMenu() {
    api.get('/api/menu').then(res => {
      const ret = res.data;
      if (ret.code == 0) {
        store.dispatch({
          type: 'update-menu',
          payload: {
            menuInfo: ret.data,
            menuLoading: false
          }
        });
      }
    });
  }
  function fetchDict() {
    api.get('/api/dict').then(res => {
      const ret = res.data;
      if (ret.code == 0) {
        store.dispatch({
          type: 'update-dict',
          payload: {
            dicts: ret.data
          }
        });
      }
    });
  }
  function fetchUserInfo() {
    store.dispatch({
      type: 'update-userInfo',
      payload: {
        userLoading: true
      }
    });
    store.dispatch({
      type: 'update-menu',
      payload: {
        menuLoading: true
      }
    });
    api.get('/api/user/userinfo').then(res => {
      const ret = res.data;
      if (ret.code == 0) {
        store.dispatch({
          type: 'update-userInfo',
          payload: {
            userInfo: ret.data,
            userLoading: false
          }
        });
        fetchMenu();
      } else {
        setUserStatus('logout');
        window.location.href = '/login';
      }
    });
  }
  useEffect(() => {
    fetchDict();
    if (checkLogin()) {
      fetchUserInfo();
    } else {
      let isIndPage = false;
      for (const i in indPage) {
        if (indPage[i] == window.location.pathname || indPage[i] + '/' == window.location.pathname) {
          isIndPage = true;
        }
      }
      if (!isIndPage) {
        window.location.pathname = '/login';
      } else if (window.location.pathname.replace(/\//g, '') !== 'login') {
        window.location.pathname = '/login';
      }
    }
  }, []);
  useEffect(() => {
    changeTheme(theme);
  }, [theme]);
  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme
  };
  return /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: getArcoLocale(),
    componentConfig: {
      Card: {
        bordered: false
      },
      List: {
        bordered: false
      },
      Table: {
        border: false
      }
    }
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    component: Login
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/root",
    component: PageLayout
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/admin",
    component: PageLayout
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/manager",
    component: PageLayout
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/user",
    component: PageLayout
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: Login
  }))))));
}
ReactDOM.render(/*#__PURE__*/React.createElement(Index, null), document.getElementById('root'));